import React, { Component } from 'react';
import './styles.css';

class InputNumberUnitLayout extends Component {
	render() {
		return (
			<div className="input-number-unit-layout">{this.props.children}</div>
		);
	}
}

export default InputNumberUnitLayout;
